import { Nullable } from './../../../interface/common/common';
import { useMemo } from 'react';

interface IProps {
  jobDescription: Nullable<string>;
}

const useParseJobDescription = ({ jobDescription }: IProps) => {
  const findImagePropsWithRegex = (string: string) => {
    const attributesRegex = /(\w+)="([^"]*)"/g;
    let match: RegExpExecArray | null;
    const result: { [key: string]: string } = {};

    while ((match = attributesRegex.exec(string)) !== null) {
      const attributeName = match[1];
      const attributeValue = match[2];
      result[attributeName] = attributeValue;
    }
    return result;
  };

  const imageOptimizedJobDescription = useMemo(() => {
    if (!jobDescription) return '';
    const listSplitWithAllTag = jobDescription.split('<');
    const fixedListSplitWithAllTag = listSplitWithAllTag.map((item) => {
      if (!item.startsWith('img')) return item;

      const imgTagAttributes = findImagePropsWithRegex(item.split('img ')[1]);
      const keys = Object.keys(imgTagAttributes);

      const MAX_WIDTH_STYLE = 'max-width: 100%;';
      if (keys.includes('style')) {
        const imgTagStyles = imgTagAttributes.style.split('; ');
        const imgTagStylesWithoutHeight = imgTagStyles.filter((style) => !style.startsWith('height'));

        const filteredKeys = keys.filter((key) => !['style', 'height'].includes(key));
        const newAttributes = filteredKeys.map((key) => `${key}="${imgTagAttributes[key]}"`).join(' ');

        const ASPECT_RATIO_STYLE = imgTagAttributes.width
          ? ` aspect-ratio: ${imgTagAttributes.width} / ${imgTagAttributes.height};`
          : '';
        const newStyle = `${imgTagStylesWithoutHeight.join('; ')}; ${MAX_WIDTH_STYLE}${ASPECT_RATIO_STYLE}`;
        return `img ${newAttributes}; style='${newStyle}'>`;
      } else {
        const filetedKeys = keys.filter((key) => !['style', 'width', 'height'].includes(key));
        const newAttributes = filetedKeys.map((key) => `${key}="${imgTagAttributes[key]}"`).join(' ');
        return `img ${newAttributes}; style='${MAX_WIDTH_STYLE}'>`;
      }
    });
    return fixedListSplitWithAllTag.join('<');
  }, [jobDescription]);

  return { imageOptimizedJobDescription };
};

export default useParseJobDescription;
